import type { IAuthOptions } from '../types/IAuthOptions';

/**
 * Параметри входу для сервера розробки без API входу (до Stage 6: GET /auth/options → 404): усі способи входу ведуть у демо-обліковий
 * запис через заголовок X-Dev-User (схема Dev сервера); реєстрації й режиму спостерігача такий сервер не має.
 */
export const legacyAuthOptions: IAuthOptions = {
  providers: { google: true, microsoft: true, password: true, idgovua: false },
  selfRegistration: false,
  observer: false,
  mode: 'dev',
  demoEmail: 'oksana@rada.gov.ua',
};
